<!-- Order Details Container -->
<div class="order-details-container">
  <!-- Header Section -->
  <div class="order-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="order-title">
          <i class="pi pi-shopping-cart mr-3"></i>
          Order Details
        </h1>
        <p class="order-subtitle">
          Complete information for order #{{ data?.order?.order_number }}
        </p>
      </div>
      <div class="header-right">
        <div class="order-status" [ngClass]="getStatusClass(data?.order?.order_status)">
          <i class="pi pi-circle-fill status-icon"></i>
          {{ data?.order?.order_status }}
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="order-content">
    <!-- Order Information Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-info-circle mr-2"></i>
          Order Information
        </h2>
      </div>
      
      <div class="info-grid">
        <div class="info-card">
          <div class="info-label">Order Number</div>
          <div class="info-value">{{ data?.order?.order_number }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Order Date</div>
          <div class="info-value">{{ data?.order?.order_date | date:'medium' }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Required Date</div>
          <div class="info-value">{{ data?.order?.date_required | date:'medium' }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Total Amount</div>
          <div class="info-value total-amount">{{ data?.order?.order_total | currency:'R' }}</div>
        </div>
      </div>
    </div>

    <!-- Clinic Information Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-building mr-2"></i>
          Clinic Information
        </h2>
      </div>
      
      <div class="clinic-info">
        <div class="clinic-header">
          <div class="clinic-name">{{ data?.order?.clinic?.name }}</div>
          <div class="clinic-id">ID: {{ data?.order?.clinic?.id }}</div>
        </div>
        
        <div class="clinic-details">
          <div class="detail-row">
            <div class="detail-label">Professional Nurse:</div>
            <div class="detail-value">{{ data?.order?.clinic?.professional_nurse }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">Contact Number:</div>
            <div class="detail-value">{{ data?.order?.clinic?.nurse_details?.contact_number }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">Address:</div>
            <div class="detail-value">
              {{ data?.order?.clinic?.street_address }}
              <span *ngIf="data?.order?.clinic?.address_line_1">, {{ data?.order?.clinic?.address_line_1 }}</span>
              <span *ngIf="data?.order?.clinic?.address_line_2">, {{ data?.order?.clinic?.address_line_2 }}</span>
            </div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">Suburb:</div>
            <div class="detail-value">{{ data?.order?.clinic?.suburb }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">City:</div>
            <div class="detail-value">{{ data?.order?.clinic?.city }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">Province:</div>
            <div class="detail-value">{{ data?.order?.clinic?.province }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">Postal Code:</div>
            <div class="detail-value">{{ data?.order?.clinic?.postal_code }}</div>
          </div>
          
          <div class="detail-row">
            <div class="detail-label">District:</div>
            <div class="detail-value">{{ data?.order?.clinic?.district }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Items Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-box mr-2"></i>
          Order Items
        </h2>
        <div class="items-count">{{ data?.order?.items?.length || 0 }} item(s)</div>
      </div>
      
      <div class="items-container">
        <div class="item-card" *ngFor="let item of data?.order?.items; let i = index">
          <div class="item-header">
            <div class="item-number">Item {{ i + 1 }}</div>
            <div class="item-total">{{ item.total_cost | currency:'R' }}</div>
          </div>
          
          <div class="item-details">
            <div class="product-info">
              <div class="product-code">{{ item.products?.stock_item_code }}</div>
              <div class="product-description">{{ item.products?.description }}</div>
              <div class="product-size">Size: {{ item.products?.size }}</div>
            </div>
            
            <div class="quantity-info">
              <div class="quantity-label">Quantity:</div>
              <div class="quantity-value">{{ item.quantity }}</div>
            </div>
            
            <div class="pricing-info">
              <div class="price-row">
                <span class="price-label">Cost (excl. VAT):</span>
                <span class="price-value">{{ item.products?.cost_excl_vat | currency:'R' }}</span>
              </div>
              <div class="price-row">
                <span class="price-label">Cost (incl. VAT):</span>
                <span class="price-value">{{ item.products?.cost_incl_vat | currency:'R' }}</span>
              </div>
              <div class="price-row total">
                <span class="price-label">Total Cost:</span>
                <span class="price-value">{{ item.total_cost | currency:'R' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Section -->
    <div class="content-section summary-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-calculator mr-2"></i>
          Order Summary
        </h2>
      </div>
      
      <div class="summary-card">
        <div class="summary-row">
          <div class="summary-label">Total Items:</div>
          <div class="summary-value">{{ data?.order?.items?.length || 0 }}</div>
        </div>
        
        <div class="summary-row">
          <div class="summary-label">Total Quantity:</div>
          <div class="summary-value">{{ getTotalQuantity() }}</div>
        </div>
        
        <div class="summary-divider"></div>
        
        <div class="summary-row total">
          <div class="summary-label">Order Total:</div>
          <div class="summary-value">{{ data?.order?.order_total | currency:'R' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
